<template>
    <div class="overflow-hidden bg-white rounded-md shadow">
        <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
            <h3 class="text-lg font-medium leading-6 text-gray-900">Plan Details</h3>
            <p class="max-w-2xl mt-1 text-sm leading-5 text-gray-500">Details and limits of your current plan</p>
        </div>
        <div class="px-4 py-5 sm:px-6">
            <dl class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-2">
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium leading-5 text-gray-500"></dt>
                    <dd class="mt-1 text-md font-medium leading-5 text-gray-900">
                        {{ plan.name }} <subscription-status :status="status" :next_billing="nextBilling" :cancel_at="cancelAt" />
                    </dd>
                    <dd class="mt-1 text-sm leading-5 tracking-wide text-gray-700">
                        Billing {{ plan.schedule }} • Next invoice on {{ nextBilling }} for {{ subscription.amount | toUSD }}
                    </dd>
                </div>
                <div class="sm:col-span-1"></div>
                <div class="sm:col-span-2">
                    <dt class="text-sm font-medium leading-5 text-gray-500">Plan limits {{ subscription.trial_period_ends }}</dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900">
                        With this plan you can have up to <span class="font-semibold">{{ plan.limits.teams }} teams</span> and up to
                        <span class="font-semibold">{{ plan.limits.users }} members</span>
                    </dd>
                </div>
                <div class="sm:col-span-2">
                    <dt class="text-sm font-medium leading-5 text-gray-500">
                        Plan usage
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900">
                        <p>
                            <span class="font-semibold">{{ teams }}</span> / {{ plan.limits.teams }} teams
                        </p>
                        <p>
                            <span class="font-semibold">{{ members }}</span> / {{ plan.limits.users }} members
                        </p>
                    </dd>
                </div>
                <div class="sm:col-span-2">
                    <a target="_blank" class="pr-6 text-sm font-semibold tracking-tight action-link text-primary-500" rel="noopener noreferrer" href="https://flowist.io#pricing"
                        >Learn more about plans on the pricing page</a
                    >
                </div>
            </dl>
        </div>
    </div>
</template>

<script>
import SubscriptionStatus from '@/components/SubscriptionStatus';

export default {
    name: 'org-plan',
    components: { SubscriptionStatus },
    props: {
        org: Object,
        plan: Object,
        subscription: Object,
    },
    computed: {
        members() {
            return this.org.memberships.length;
        },
        teams() {
            return this.$store.state.teams.all.length;
        },
        status() {
            return this.subscription.status;
        },
        nextBilling() {
            return this.$moment
                .unix(this.subscription.current_period_end)
                .local()
                .format('MMM D');
        },
        isCancelling() {
            return this.subscription.cancel_at_period_end;
        },
        cancelAt() {
            return this.$moment
                .unix(this.subscription.cancel_at)
                .local()
                .format('MMM D');
        },
    },
    filters: {
        toUSD(value) {
            return `$${(value / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        },
    },
};
</script>

<style scoped>
.action-link::after {
    transform: rotate(-40deg);
    content: '→';
    margin-left: 4px;
    position: absolute;
}
</style>
